import config from '../../config/config';
import { sessionAwareFetch } from './sessionAwareFetch';
import { applySessionTiming, clearSessionTiming } from './sessionRefresh';

export const authService = {
  async login(email, password) {
    const response = await fetch(`${config.apimUrl}/authentication-api/Login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Ocp-Apim-Subscription-Key': config.apimKeyAuthenticationService,
      },
      credentials: 'include',
      body: JSON.stringify({ Email: email, Password: password }),
    });

    if (!response.ok) {
      throw new Error('Incorrect username or password. Please try again.');
    }

    const session = await response.json();
    applySessionTiming(session);
    return session;
  },

  async refreshSession() {
    const response = await fetch(`${config.apimUrl}/authentication-api/Refresh`, {
      method: 'POST',
      headers: {
        'Ocp-Apim-Subscription-Key': config.apimKeyAuthenticationService,
      },
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Session refresh failed');
    }

    const session = await response.json();
    applySessionTiming(session);
    return session;
  },

  async fetchUser() {
    const response = await sessionAwareFetch(`${config.apimUrl}/account-api`, {
      method: 'GET',
      headers: {
        'Ocp-Apim-Subscription-Key': config.apimKeyAccountService,
      },
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    return await response.json(); // { Email, Role }
  },

  async logOut() {
    const response = await fetch(`${config.apimUrl}/authentication-api/Logout`, {
      method: 'POST',
      headers: {
        'Ocp-Apim-Subscription-Key': config.apimKeyAuthenticationService,
      },
      credentials: 'include',
    });

    clearSessionTiming();

    if (!response.ok) {
      throw new Error('Logout failed');
    }

    return;
  },
};
